import { FONT_WEIGHT, Heading as _Heading } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const HeadingBold = styled(_Heading)`
  font-weight: ${FONT_WEIGHT.BOLD};
`;
